import Link from 'next/link'
import { Button } from 'reactstrap'

const HeroAndButton = (props) => (
  <div
    className={`d-flex justify-content-between align-items-center ${
      props.className ?? ''
    }`}
  >
    <h1 className='hero-heading m-0'>{props.hero}</h1>
    {props.btn && props.btn.href && (
      <Link href={props.btn.href}>
        <Button color='link' className='text-primary p-0 text-right'>
          {props.btn.label}
        </Button>
      </Link>
    )}
    {props.btn && props.btn.onClick && (
      <Button
        color='link'
        className='text-primary p-0 text-right'
        onClick={props.btn.onClick}
      >
        {props.btn.label}
      </Button>
    )}
  </div>
)

export default HeroAndButton
